import Animated from "react-native-reanimated";
import { useScrollContext } from "@navigations/utils/ScrollContext";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { css } from "styled-components/native";
import { LayoutContainerProps } from "./types";
import { DefaultTheme } from "styled-components/native";
import { useSelector } from "react-redux";

const contentSizedStyle = {
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: "auto" as const,
  height: "auto" as const,
  maxHeight: "none" as const,
  overflow: "visible" as const,
  touchAction: "pan-y" as const,
};

const LayoutContainer = ({
  children,
  showAsPopover,
  backgroundColor = "core-02",
  allowFlex = true,
  contentSized = false,
  nativeID,
}: LayoutContainerProps) => {
  const [_, __, style] = useScrollContext();
  const theme = useTheme();
  const safeStyle = style || {};
  const navigationHeight = useSelector(
    (state: { appState?: { navigationHeight?: number } }) =>
      state.appState?.navigationHeight ?? 0
  );

  if (theme.isLargeScreen)
    return (
      <DesktopView
        nativeID={nativeID}
        backgroundColor={backgroundColor}
        style={contentSized ? contentSizedStyle : undefined}
      >
        {children}
      </DesktopView>
    );

  return (
    <StyledView
      nativeID={nativeID}
      style={
        contentSized
          ? [contentSizedStyle, { marginTop: navigationHeight }]
          : [showAsPopover ? {} : safeStyle]
      }
      isLargeScreen={theme.isLargeScreen}
      allowFlex={contentSized ? false : allowFlex}
    >
      {children}
    </StyledView>
  );
};

const StyledView = styled(Animated.View)<{
  isLargeScreen?: boolean;
  allowFlex?: boolean;
}>`
  background-color: ${({
    theme,
    isLargeScreen,
  }: {
    theme: DefaultTheme;
    isLargeScreen: boolean;
  }) => (isLargeScreen ? theme["core-01"] : theme["core-02"])};
  ${({ theme, allowFlex }: { theme: DefaultTheme; allowFlex: boolean }) =>
    allowFlex &&
    css`
      flex: ${theme.isMobile ? 1 : "auto"};
    `}
  max-height: 100%;
`;

const DesktopView = styled.View<{
  backgroundColor: string;
}>`
  flex: 1;
  flex-basis: auto;
  ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor &&
    css`
      background-color: ${({ theme }: { theme: DefaultTheme }) =>
        theme[backgroundColor as keyof DefaultTheme] as string};
    `}
`;

export default LayoutContainer;
